import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import TextInfo, {
  TEXT_FONT_WEIGHT,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN
} from "@gc-npm/components.text";

import {
  generateQueryString,
} from "@/utils/normalizers/product";
import styles from "./style";
import { getFullUrl } from "@/utils/htmlUtils";
import Button, { BUTTON_OPERATION, BUTTON_TYPE, BUTTON_WIDTH } from "@gc-npm/components.button";
import { actions as devicesListActions } from "@/reducers/devices-list";

const Pagination = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  const { query } = router;
  const {
    selectedFilters,
    sort,
    id,
    getMoreFetching
  } = useSelector((state) => state.devicesList);

  const {
    totalNumberOfPages,
    totalNumberOfElements,
    renderedCount
  } = useSelector((state) => state.devicesList.pagination);

  if (totalNumberOfPages <= 1) return null;

  const handleOnChangePage = (value) => {
    const selectedFiltersNew = selectedFilters;
    selectedFiltersNew.pageIndex = value;
    selectedFiltersNew.id = id;
    const url = getFullUrl(`/${id}?sort=${sort}&${generateQueryString(selectedFiltersNew)
      }`, query);
    router.push(url, undefined, { shallow: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleShowMore = () => {
    if (!getMoreFetching) {
      dispatch(
        devicesListActions.initGetMoreDevicesList({
          id,
          queryParams: query,
          showMore: true,
        })
      );
    }
  };


  return (
    <div>
      <div className="pagination" role="group" aria-label="Paginación de resultados">
        {renderedCount < totalNumberOfElements && (
          <Button
            operation={getMoreFetching ? BUTTON_OPERATION.LOADING : BUTTON_OPERATION.NO}
            type={BUTTON_TYPE.PRIMARY}
            width={BUTTON_WIDTH.MEDIUM}
            onClick={handleShowMore}
            label={"Ver más resultados"}
            taggingInfo={{
              componentName: "button-ver-mas",
              componentVariation: "all",
              componentContent: "Ver más resultados",
              componentPerso: "",
              componentProduct: "",
            }}
          />
        )}
        <div role="status" aria-atomic="true">
          <TextInfo
            text={`Mostrando ${renderedCount} de ${totalNumberOfElements}`}
            align={TEXT_ALIGN.CENTER}
            size={TEXT_SIZE.CAPTION3}
            color={TEXT_COLOR.GREY_700}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default Pagination;
